import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-act-statuses',
  templateUrl: './act-statuses.component.html',
  styleUrls: ['./act-statuses.component.css']
})
export class ActStatusesComponent implements OnInit {
    public itemsListActStatuses: Item[] = [];

    constructor(private datatask: DataTaskService, private stateService: StateService) { }

    public goToFunc(state: any) {
        switch (state) {
            case 'actstatus':
                this.stateService?.go('actstatus', { actstatus_keyno: '0' });
                break;
            default:
                break;
        }
    }

    private async loadActStatuses() {
        this.itemsListActStatuses = await this.datatask.Post(1331);
    }

    private async init() {
        await this.loadActStatuses();
    }

    ngOnInit(): void {
        this.init();
    }
}


//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('actStatuses', {
//        templateUrl: 'views/components/views/actStatuses/actStatuses.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'actStatusesService', function (stateService, actStatusesService) {
//            const vm = this;

//            vm.model = {
//                itemsListActStatuses: []
//            };

//            async function loadActStatuses() {
//                vm.model.itemsListActStatuses = await actStatusesService.listActStatuses();
//            }

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'actstatus':
//                        go({ actstatus_keyno: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            vm.$onInit = function () {
//                loadActStatuses();
//            }
//        }]
//    });
//})();
